import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import { Reveal, SectionEyebrow, ArrowIcon } from "./Section";
import { useI18n } from "../../lib/i18n";

/** Strong "call us / contact us" callout used on every page above footer. */
const LeadCallout = ({ settings }) => {
  const { t, lang, pick } = useI18n();
  const L = {
    tr: {
      eyebrow: "Bir Sonraki Adım",
      title: "Bir sonraki projeniz için sizi arıyoruz.",
      body: "Prestijli bir proje, uluslararası bir işbirliği ya da yatırım hakkında konuşalım. Ekibimiz 24 saat içinde geri dönüş yapar.",
      cta: "Bize Ulaşın",
      call: "Hemen Arayın",
    },
    en: {
      eyebrow: "The Next Step",
      title: "We're one call away from your next landmark.",
      body: "Let's discuss a prestige development, an international partnership, or an investment opportunity. Our team responds within 24 hours.",
      cta: "Contact Us",
      call: "Call Now",
    },
    ar: {
      eyebrow: "الخطوة التالية",
      title: "نحن على بعد اتصال من مشروعك القادم.",
      body: "دعنا نتحدث عن مشروع مرموق أو شراكة دولية أو فرصة استثمارية. فريقنا يستجيب خلال 24 ساعة.",
      cta: "تواصل معنا",
      call: "اتصل الآن",
    },
  };
  const s = L[lang] || L.tr;
  const phone = settings?.contact_phone || "";
  const email = settings?.contact_email || "";

  return (
    <section className="bg-brand-light" data-testid="lead-callout">
      <div className="container-x py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-7">
            <Reveal>
              <SectionEyebrow>{s.eyebrow}</SectionEyebrow>
              <h2 className="display display-lg mt-6 max-w-2xl">{s.title}</h2>
              <p className="mt-6 text-brand-medium max-w-xl leading-relaxed">{s.body}</p>
            </Reveal>
          </div>
          <div className="lg:col-span-5">
            <Reveal delay={0.1}>
              <div className="bg-white border border-black/5 p-6 md:p-8">
                {phone ? (
                  <a href={`tel:${phone}`} className="flex items-start gap-4 py-2" data-testid="lead-call">
                    <Phone size={18} strokeWidth={1.5} className="text-brand-gold mt-1" />
                    <div>
                      <div className="text-[0.66rem] tracking-[0.28em] uppercase text-brand-medium">{s.call}</div>
                      <div className="text-brand-navy font-serif text-2xl mt-1">{phone}</div>
                    </div>
                  </a>
                ) : null}
                {email ? (
                  <a href={`mailto:${email}`} className="flex items-start gap-4 py-2 border-t border-black/5 mt-3 pt-4" data-testid="lead-email">
                    <Mail size={18} strokeWidth={1.5} className="text-brand-gold mt-1" />
                    <div>
                      <div className="text-[0.66rem] tracking-[0.28em] uppercase text-brand-medium">E-mail</div>
                      <div className="text-brand-navy mt-1">{email}</div>
                    </div>
                  </a>
                ) : null}
                <div className="mt-6">
                  <Link to="/contact" className="btn-outline-dark w-full justify-center" data-testid="lead-cta">
                    <span>{s.cta}</span>
                    <ArrowIcon />
                  </Link>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeadCallout;
